export const initialState = {
    approveRequestPending: false,
    approveRequestSuccess: false,
    approveRequestError: false,
    selectedReason:''
};


const ApproveRejectReducer = (state=initialState, action) => {
    switch (action.type) {
        case 'APPROVE_REQUEST_PENDING':{
            return{
                ...state,
                approveRequestPending:action.payload
            }
        }
        case 'APPROVE_REQUEST_SUCCESS':{
            return{
                ...state,
                approveRequestSuccess: action.payload
            }
        }
        case 'APPROVE_REQUEST_ERROR':{
            return{
                ...state,
                approveRequestError : action.payload
            }
        }
        case 'SELECTED_REASON':{
            return{
                ...state,
                selectedReason : action.value
            }
        }
        default:
            return state;
    }
};

export default ApproveRejectReducer;
